(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 767px)');
  const ease = 'cubic-bezier(.16,1,.3,1)';
  const initialise = (root = document) => {
    root.querySelectorAll('[data-han-gallery-controls]').forEach(controls => {
      if (controls.hasAttribute('data-han-source-ready')) return;
      const gallery = controls.closest('.product__main')?.querySelector('.product__media-list[data-gallery-type="static_column_aside"]');
      if (!gallery) return;
      controls.setAttribute('data-han-source-ready', '');
      const steps = controls.querySelector('[data-han-gallery-steps]');
      const indexLabel = controls.querySelector('[data-han-gallery-index]');
      const totalLabel = controls.querySelector('[data-han-gallery-total]');
      const caption = controls.querySelector('.han-gallery-caption');
      if (!steps || !indexLabel || !totalLabel) return;
      let items = [], active = 0, frame = 0;
      const seen = new WeakSet();
      const show = index => {
        active = Math.max(0, Math.min(items.length - 1, index));
        indexLabel.textContent = String(active + 1).padStart(2, '0');
        totalLabel.textContent = String(items.length).padStart(2, '0');
        caption.textContent = items[active]?.querySelector('img')?.alt || gallery.getAttribute('aria-label') || '';
        [...steps.children].forEach((button, i) => i === active ? button.setAttribute('aria-current', 'true') : button.removeAttribute('aria-current'));
      };
      const scrollTo = (index, behavior = reduced.matches ? 'auto' : 'smooth') => {
        const target = items[index];
        if (!target) return;
        const offset = target.getBoundingClientRect(), origin = gallery.getBoundingClientRect();
        gallery.scrollTo({left:mobile.matches ? gallery.scrollLeft + offset.left - origin.left : 0, top:mobile.matches ? 0 : gallery.scrollTop + offset.top - origin.top, behavior});
        show(index);
      };
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || seen.has(entry.target)) return;
          seen.add(entry.target);
          const image = entry.target.querySelector('img');
        });
      }, {root:gallery,threshold:[0,.15,.3,.5,.75,1]});
      const rebuild = () => {
        observer.disconnect();
        items = [...gallery.children].filter(item => item.classList.contains('product__media-item') && !item.hidden && getComputedStyle(item).display !== 'none');
        steps.replaceChildren(...items.map((item,index) => {
          observer.observe(item);
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', `${controls.getAttribute('aria-label')} ${index + 1}`);
          button.addEventListener('click', () => scrollTo(index));
          return button;
        }));
        show(Math.min(active, items.length - 1));
      };
      gallery.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const origin = gallery.getBoundingClientRect();
          let best = 0, distance = Infinity;
          items.forEach((item,i) => {
            const rect = item.getBoundingClientRect();
            const delta = Math.abs(mobile.matches ? rect.left - origin.left : rect.top - origin.top);
            if (delta < distance) {best = i;distance = delta;}
          });
          show(best);
        });
      }, {passive:true});
      gallery.tabIndex = 0;
      gallery.addEventListener('keydown', event => {
        if (event.target !== gallery) return;
        const direction = {ArrowRight:1,ArrowDown:1,ArrowLeft:-1,ArrowUp:-1}[event.key];
        if (!direction) return;
        event.preventDefault();scrollTo(Math.max(0,Math.min(items.length-1,active+direction)));
      });
      new MutationObserver(rebuild).observe(gallery,{childList:true});
      let resizeFrame = 0;
      const resize = () => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(() => scrollTo(active, 'auto'));
      };
      mobile.addEventListener('change', resize);
      window.addEventListener('resize', resize, {passive:true});
      document.addEventListener('variant:change', event => {
        const mediaId = event.detail?.variant?.featured_media?.id;
        if (!mediaId) return;
        requestAnimationFrame(() => {
          const image = items.find(item => item.dataset.mediaId?.endsWith('-' + mediaId))?.querySelector('img');
        });
      });
      rebuild();
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
